<div>
  <span
    class="glyphicon glyphicon-remove form-control-feedback fix-error-icon"
  ></span>
  <span class="sr-only"></span>
  <div class="error-msg">
    {{ errorMsg }}
  </div>
</div>
